// import { useFetchCategoryVariants } from "hooks/useFetchCategoryVariants";
// import { useFetchVariants } from "hooks/useFetchDetailVariants";
// import React, { useEffect, useMemo, useState } from "react";
// import {
//     Button,
//     Form,
//     InputGroup,
//     OverlayTrigger,
//     Tooltip
// } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { MdOutlineLibraryAddCheck } from "react-icons/md";
// import { useLocation, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";

// const PricingAndStockInfoV2 = () => {

//     const location = useLocation()

//     const {
//         watch,
//         setValue,
//         register,
//         formState: { errors },
//     } = useFormContext();

//     const categoryId = watch("categoryId");

//     const { data: variantsData, isLoading: variantsLoading } = useFetchVariants();
//     const { data: categoryVariantsData, isLoading: categoryVariantsLoading } =
//         useFetchCategoryVariants();

//     const filteredCategoryVariants = useMemo(() => {
//         if (!categoryVariantsData || !categoryId) return [];
//         return categoryVariantsData?.data?.data?.filter(
//             (set) => set.categoryId === categoryId
//         );
//     }, [categoryVariantsData, categoryId]);

//     const variantsIds = useMemo(() => {
//         return filteredCategoryVariants?.flatMap((set) =>
//             set.options.map((fs) => fs.variantId)
//         );
//     }, [filteredCategoryVariants]);

//     const filteredVariantsOption = useMemo(() => {
//         if (!variantsData || variantsIds.length === 0) return [];
//         return variantsData?.data?.data?.filter((variant) =>
//             variantsIds.includes(variant.id)
//         );
//     }, [variantsData, variantsIds]);

//     const [inputs, setInputs] = useState([]);

//     const permutations = useMemo(
//         () => generatePermutations(filteredVariantsOption),
//         [filteredVariantsOption]
//     );

//     // Create dynamic rows
//     // useEffect(() => {
//     //     const initialInputs = permutations.flatMap((set) =>
//     //         set.permutations.map((perm) => {
//     //             const entries = Object.values(perm); // ["Red","M","Cotton"]

//     //             const obj = {};

//     //             // Dynamically create variant1, variant2, variant3...
//     //             entries.forEach((value, idx) => {
//     //                 obj[`variant${idx + 1}`] = value;
//     //             });

//     //             // Always include up to variant5 (optional)
//     //             for (let i = entries.length + 1; i <= 5; i++) {
//     //                 obj[`variant${i}`] = "";
//     //             }

//     //             return {
//     //                 ...obj,
//     //                 originalPrice: "",
//     //                 discountedPrice: "",
//     //                 skuCode: "",
//     //                 quantity: "",
//     //             };
//     //         })
//     //     );

//     //     setInputs(initialInputs);
//     //     setValue("pricingAndStocks", initialInputs);
//     // }, [permutations]);

//     useEffect(() => {
//         if (!permutations) return;

//         const apiRows = location.state?.pricingAndStocks || []; // <-- incoming API rows

//         const generatedRows = permutations.flatMap((set) =>
//             set.permutations.map((perm) => {
//                 const entries = Object.values(perm);

//                 const obj = {};
//                 entries.forEach((value, idx) => {
//                     obj[`variant${idx + 1}`] = value;
//                 });

//                 for (let i = entries.length + 1; i <= 5; i++) {
//                     obj[`variant${i}`] = "";
//                 }

//                 return obj;
//             })
//         );

//         // 🔥 merge API rows
//         const mergedRows = generatedRows.map((row) => {
//             const match = apiRows.find((api) =>
//                 [...Array(5)].every((_, i) => {
//                     const key = `variant${i + 1}`;
//                     return (api[key] || "") === (row[key] || "");
//                 })
//             );

//             return {
//                 ...row,
//                 originalPrice: match?.originalPrice ?? "",
//                 discountedPrice: match?.discountedPrice ?? "",
//                 skuCode: match?.skuCode ?? "",
//                 quantity: match?.quantity ?? "",
//                 id: match?.id ?? 0,
//                 productId: match?.productId ?? 0,
//                 status: match?.status ?? true,
//                 isDefault: match?.isDefault ?? false
//             };
//         });

//         setInputs(mergedRows);
//         setValue("pricingAndStocks", mergedRows);

//     }, [permutations, location.state]);

//     const pricingAndStockFound = watch("pricingAndStocks");
//     // console.log(pricingAndStockFound)

//     useEffect(() => {
//         if (pricingAndStockFound) {
//             setInputs(pricingAndStockFound);
//         }
//     }, [pricingAndStockFound]);

//     // const handleInputChange = (index, field, value) => {
//     //     const updated = inputs.map((row, i) =>
//     //         i === index ? { ...row, [field]: value } : row
//     //     );
//     //     setInputs(updated);
//     //     setValue("pricingAndStocks", updated);
//     // };

//     const handleInputChange = (index, field, value) => {
//         let updated;

//         if (field === "isDefault") {
//             // 🔥 Make it behave like radio
//             updated = inputs.map((row, i) => ({
//                 ...row,
//                 isDefault: i === index ? value : false
//             }));
//         } else {
//             updated = inputs.map((row, i) =>
//                 i === index ? { ...row, [field]: value } : row
//             );
//         }

//         setInputs(updated);
//         setValue("pricingAndStocks", updated);
//     };

//     const handleApplyAll = (field, value) => {
//         const updated = inputs.map((row) => ({ ...row, [field]: value }));
//         setInputs(updated);
//         setValue("pricingAndStocks", updated);
//     };

//     const handleApplyButtonClick = (index, field) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You want apply to all",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#3085d6",
//             cancelButtonColor: "#d33",
//             confirmButtonText: "Yes",
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 handleApplyAll(field, inputs[index][field]);
//             }
//         });

//     };

//     if (variantsLoading || categoryVariantsLoading) {
//         return (
//             <div className="d-flex py-3 justify-content-center align-items-center">
//                 <Button variant="falcon-default" size="sm" className="fs-10">
//                     Loading...
//                 </Button>
//             </div>
//         );
//     }

//     return (
//         <table className="table table-bordered ">
//             {permutations.map((set, setIndex) => (
//                 <React.Fragment key={setIndex}>
//                     <thead>
//                         <tr>
//                             <th
//                                 colSpan={set.order.length + 5}
//                                 className="bg-body-tertiary text-left text-800"
//                             >
//                                 {filteredVariantsOption[setIndex]?.name}
//                             </th>
//                         </tr>

//                         <tr className="bg-body-tertiary text-center text-800">
//                             {set.order.map((col) => (
//                                 <th key={col}>{col}</th>
//                             ))}
//                             <th>Price</th>
//                             <th>Special Price</th>
//                             <th>Stock</th>
//                             <th>SKU</th>
//                             <th>Default</th>
//                         </tr>
//                     </thead>

//                     <tbody>

//                         {set.permutations.map((perm, permIndex) => {
//                             const permValues = Object.values(perm);

//                             const rowIndex = inputs.findIndex((row) =>
//                                 permValues.every((val, idx) => row[`variant${idx + 1}`] === val)
//                             );

//                             const row = inputs[rowIndex];

//                             return (
//                                 <tr key={permIndex}>
//                                     {set.order.map((col, colIndex) => {
//                                         // Find how many consecutive rows have the same value for this column
//                                         let rowspan = 1;
//                                         for (let i = permIndex + 1; i < set.permutations.length; i++) {
//                                             if (set.permutations[i][col] === perm[col]) {
//                                                 rowspan++;
//                                             } else {
//                                                 break;
//                                             }
//                                         }

//                                         // Only render the cell if this is the first occurrence
//                                         const isFirstOccurrence =
//                                             permIndex === 0 ||
//                                             set.permutations[permIndex - 1][col] !== perm[col];

//                                         return isFirstOccurrence ? (
//                                             <td key={col} className="text-center align-middle" rowSpan={rowspan}>
//                                                 {perm[col]}
//                                             </td>
//                                         ) : null;
//                                     })}

//                                     {/* Price */}
//                                     <td>
//                                         <InputGroup>
//                                             <Form.Control
//                                                 type="number"
//                                                 value={row?.originalPrice || ""}
//                                                 onChange={(e) =>
//                                                     handleInputChange(
//                                                         rowIndex,
//                                                         "originalPrice",
//                                                         Number(e.target.value)
//                                                     )
//                                                 }
//                                             />
//                                             <OverLayButton
//                                                 toolTip="Apply to All"
//                                                 icon={<MdOutlineLibraryAddCheck />}
//                                                 onClick={() =>
//                                                     handleApplyButtonClick(rowIndex, "originalPrice")}
//                                             />
//                                         </InputGroup>
//                                     </td>

//                                     {/* Special Price */}
//                                     <td>
//                                         <InputGroup>
//                                             <Form.Control
//                                                 type="number"
//                                                 value={row?.discountedPrice || ""}
//                                                 onChange={(e) =>
//                                                     handleInputChange(
//                                                         rowIndex,
//                                                         "discountedPrice",
//                                                         Number(e.target.value)
//                                                     )
//                                                 }
//                                             />
//                                             <OverLayButton
//                                                 toolTip="Apply to All"
//                                                 icon={<MdOutlineLibraryAddCheck />}
//                                                 onClick={() =>
//                                                     handleApplyButtonClick(rowIndex, "discountedPrice")
//                                                 }
//                                             />

//                                         </InputGroup>
//                                     </td>

//                                     {/* Stock */}
//                                     <td>
//                                         <InputGroup>
//                                             <Form.Control
//                                                 type="number"
//                                                 value={row?.quantity || ""}
//                                                 onChange={(e) =>
//                                                     handleInputChange(
//                                                         rowIndex,
//                                                         "quantity",
//                                                         Number(e.target.value)
//                                                     )
//                                                 }
//                                             />
//                                             <OverLayButton
//                                                 toolTip="Apply to All"
//                                                 icon={<MdOutlineLibraryAddCheck />}
//                                                 onClick={() =>
//                                                     handleApplyButtonClick(rowIndex, "quantity")
//                                                 }
//                                             />
//                                         </InputGroup>
//                                     </td>

//                                     {/* SKU */}
//                                     <td>
//                                         <Form.Control
//                                             type="text"
//                                             value={row?.skuCode || ""}
//                                             onChange={(e) =>
//                                                 handleInputChange(rowIndex, "skuCode", e.target.value)
//                                             }
//                                         />
//                                     </td>

//                                     <td>
//                                         <Form.Check
//                                             type="checkbox"
//                                             className="text-center mt-2"
//                                             checked={row?.isDefault ?? false} // ✅ default checked
//                                             onChange={(e) =>
//                                                 handleInputChange(rowIndex, "isDefault", e.target.checked)
//                                             }
//                                         />
//                                     </td>
//                                 </tr>
//                             );
//                         })}

//                     </tbody>

//                 </React.Fragment>
//             ))}
//         </table>
//     );
// };

// function generatePermutations(variants) {
//     if (!Array.isArray(variants) || variants.length === 0) return [];

//     return variants.map((variant) => {
//         const order = [];
//         const groups = [];

//         // Extract option groups dynamically
//         (variant.options || []).forEach((group) => {
//             order.push(group.name); // preserve order

//             groups.push({
//                 key: group.name,
//                 values: group.options || [],
//             });
//         });

//         // Now generate cartesian product of all groups
//         const permutations = cartesianProduct(groups);

//         return {
//             variant: variant.name,
//             permutations,
//             order,
//         };
//     });
// }

// function cartesianProduct(groups) {
//     if (groups.length === 0) return [];

//     const result = [];

//     const generate = (index, current) => {
//         if (index === groups.length) {
//             result.push({ ...current });
//             return;
//         }

//         const group = groups[index];

//         group.values.forEach((value) => {
//             generate(index + 1, { ...current, [group.key]: value });
//         });
//     };

//     generate(0, {});
//     return result;
// }

// function OverLayButton({ toolTip, onClick, icon }) {
//     return <OverlayTrigger
//         overlay={
//             <Tooltip
//                 style={{ position: "fixed" }}
//                 id="overlay-trigger-example"
//             >
//                 {toolTip}
//             </Tooltip>
//         }
//     >
//         <Button
//             variant="secondary"
//             onClick={onClick}
//         >
//             {icon && icon}
//         </Button>
//     </OverlayTrigger>
// }

// export default PricingAndStockInfoV2;

// import React, { useEffect, useState } from "react";
// import {
//     Button,
//     Form,
//     InputGroup,
//     OverlayTrigger,
//     Tooltip
// } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { MdOutlineLibraryAddCheck } from "react-icons/md";
// import { useLocation } from "react-router-dom";
// import Swal from "sweetalert2";
// import OverLayButton from "components/common/OverLayButton"
// const PricingAndStockInfoV2 = () => {

//     const location = useLocation()

//     const {
//         watch,
//         setValue,
//         register,
//         formState: { errors },
//     } = useFormContext();

//     const [inputs, setInputs] = useState([]);
//     const [permutations, setPermutations] = useState([]);

//     const generateTrigger = watch("generatePermutations");
//     const variants = watch("productVariants");

//     // console.log("variants: ", variants)

//     useEffect(() => {
//         if (!variants || !variants.length) return;

//         // 🔹 Generate permutations either on trigger OR when form already has variants (edit mode)
//         if (generateTrigger || location.state?.productVariants) {
//             const generatedPermutations = generatePermutations(variants);
//             setPermutations(generatedPermutations);
//         }
//     }, [generateTrigger, variants, location.state]);

//     // useEffect(() => {
//     //     if (!generateTrigger) return;           // ❌ no click yet
//     //     if (!variants || !variants.length) return;

//     //     const generatedPermutations = generatePermutations(variants);
//     //     setPermutations(generatedPermutations);

//     // }, [generateTrigger]);

//     // const permutations = useMemo(
//     //     () => generatePermutations(filteredVariantsOption),
//     //     [filteredVariantsOption]
//     // );

//     // Create dynamic rows
//     // useEffect(() => {
//     //     const initialInputs = permutations.flatMap((set) =>
//     //         set.permutations.map((perm) => {
//     //             const entries = Object.values(perm); // ["Red","M","Cotton"]

//     //             const obj = {};

//     //             // Dynamically create variant1, variant2, variant3...
//     //             entries.forEach((value, idx) => {
//     //                 obj[`variant${idx + 1}`] = value;
//     //             });

//     //             // Always include up to variant5 (optional)
//     //             for (let i = entries.length + 1; i <= 5; i++) {
//     //                 obj[`variant${i}`] = "";
//     //             }

//     //             return {
//     //                 ...obj,
//     //                 originalPrice: "",
//     //                 discountedPrice: "",
//     //                 skuCode: "",
//     //                 quantity: "",
//     //             };
//     //         })
//     //     );

//     //     setInputs(initialInputs);
//     //     setValue("pricingAndStocks", initialInputs);
//     // }, [permutations]);

//     useEffect(() => {
//         if (!permutations.length) return;

//         const apiRows = location.state?.pricingAndStocks || [];

//         const generatedRows = permutations.flatMap((set) =>
//             set.permutations.map((perm) => {
//                 const entries = Object.values(perm);
//                 const obj = {};

//                 entries.forEach((value, idx) => {
//                     obj[`variant${idx + 1}`] = value;
//                 });

//                 for (let i = entries.length + 1; i <= 5; i++) {
//                     obj[`variant${i}`] = "";
//                 }

//                 return obj;
//             })
//         );

//         const mergedRows = generatedRows.map((row) => {
//             const match = apiRows.find((api) =>
//                 [...Array(5)].every((_, i) => {
//                     const key = `variant${i + 1}`;
//                     return (api[key] || "") === (row[key] || "");
//                 })
//             );

//             return {
//                 ...row,
//                 originalPrice: match?.originalPrice ?? "",
//                 discountedPrice: match?.discountedPrice ?? "",
//                 skuCode: match?.skuCode ?? "",
//                 quantity: match?.quantity ?? "",
//                 id: match?.id ?? 0,
//                 productId: match?.productId ?? 0,
//                 status: match?.status ?? true,
//                 isDefault: match?.isDefault ?? false
//             };
//         });

//         setInputs(mergedRows);
//         setValue("pricingAndStocks", mergedRows);

//     }, [permutations]);

//     const pricingAndStockFound = watch("pricingAndStocks");
//     console.log("pricingAndStockFound", pricingAndStockFound)
//     // console.log(pricingAndStockFound)

//     useEffect(() => {
//         if (pricingAndStockFound) {
//             setInputs(pricingAndStockFound);
//         }
//     }, [pricingAndStockFound]);

//     // const handleInputChange = (index, field, value) => {
//     //     const updated = inputs.map((row, i) =>
//     //         i === index ? { ...row, [field]: value } : row
//     //     );
//     //     setInputs(updated);
//     //     setValue("pricingAndStocks", updated);
//     // };

//     const handleInputChange = (index, field, value) => {
//         let updated;

//         if (field === "isDefault") {
//             // 🔥 Make it behave like radio
//             updated = inputs.map((row, i) => ({
//                 ...row,
//                 isDefault: i === index ? value : false
//             }));
//         } else {
//             updated = inputs.map((row, i) =>
//                 i === index ? { ...row, [field]: value } : row
//             );
//         }

//         setInputs(updated);
//         setValue("pricingAndStocks", updated);
//     };

//     const handleApplyAll = (field, value) => {
//         const updated = inputs.map((row) => ({ ...row, [field]: value }));
//         setInputs(updated);
//         setValue("pricingAndStocks", updated);
//     };

//     const handleApplyButtonClick = (index, field) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You want apply to all",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#3085d6",
//             cancelButtonColor: "#d33",
//             confirmButtonText: "Yes",
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 handleApplyAll(field, inputs[index][field]);
//             }
//         });

//     };

//     // if (variantsLoading || categoryVariantsLoading) {
//     //     return (
//     //         <div className="d-flex py-3 justify-content-center align-items-center">
//     //             <Button variant="falcon-default" size="sm" className="fs-10">
//     //                 Loading...
//     //             </Button>
//     //         </div>
//     //     );
//     // }

//     return (
//         <table className="table table-bordered ">
//             {pricingAndStockFound?.length > 0 && permutations.map((set, setIndex) => (
//                 <React.Fragment key={setIndex}>
//                     <thead>
//                         {/* <tr>
//                             <th
//                                 colSpan={set.order.length + 5}
//                                 className="bg-body-tertiary text-left text-800"
//                             >
//                                 {variants[setIndex]?.name}
//                             </th>
//                         </tr> */}

//                         <tr className="bg-body-tertiary text-center text-800">
//                             {set.order.map((col) => (
//                                 <th key={col}>{col}</th>
//                             ))}
//                             <th>Price</th>
//                             <th>Special Price</th>
//                             <th>Stock</th>
//                             <th>SKU</th>
//                             <th>Default</th>
//                             <th>Active</th>
//                         </tr>
//                     </thead>

//                     <tbody>

//                         {set.permutations.map((perm, permIndex) => {
//                             const permValues = Object.values(perm);

//                             const rowIndex = inputs.findIndex((row) =>
//                                 permValues.every((val, idx) => row[`variant${idx + 1}`] === val)
//                             );

//                             const row = inputs[rowIndex];

//                             return (
//                                 <tr key={permIndex}>
//                                     {set.order.map((col, colIndex) => {
//                                         // Find how many consecutive rows have the same value for this column
//                                         let rowspan = 1;
//                                         for (let i = permIndex + 1; i < set.permutations.length; i++) {
//                                             if (set.permutations[i][col] === perm[col]) {
//                                                 rowspan++;
//                                             } else {
//                                                 break;
//                                             }
//                                         }

//                                         // Only render the cell if this is the first occurrence
//                                         const isFirstOccurrence =
//                                             permIndex === 0 ||
//                                             set.permutations[permIndex - 1][col] !== perm[col];

//                                         return isFirstOccurrence ? (
//                                             <td key={col} className="text-center align-middle" rowSpan={rowspan}>
//                                                 {perm[col]}
//                                             </td>
//                                         ) : null;
//                                     })}

//                                     {/* Price */}
//                                     <td>
//                                         <InputGroup>
//                                             <Form.Control
//                                                 type="number"
//                                                 value={row?.originalPrice || ""}
//                                                 onChange={(e) =>
//                                                     handleInputChange(
//                                                         rowIndex,
//                                                         "originalPrice",
//                                                         Number(e.target.value)
//                                                     )
//                                                 }
//                                                 isInvalid={!!errors?.pricingAndStocks?.[rowIndex]?.originalPrice}
//                                             />
//                                             <OverLayButton
//                                                 toolTip="Apply to All"
//                                                 icon={<MdOutlineLibraryAddCheck />}
//                                                 onClick={() =>
//                                                     handleApplyButtonClick(rowIndex, "originalPrice")}
//                                             />
//                                         </InputGroup>
//                                         {errors?.pricingAndStocks?.[rowIndex]?.originalPrice && (
//                                             <p className="text-danger fs-10 mb-0 pb-0" >
//                                                 {errors.pricingAndStocks[rowIndex].originalPrice.message}
//                                             </p>
//                                         )}
//                                     </td>

//                                     {/* Special Price */}
//                                     <td>
//                                         <InputGroup>
//                                             <Form.Control
//                                                 type="number"
//                                                 value={row?.discountedPrice || ""}
//                                                 onChange={(e) =>
//                                                     handleInputChange(
//                                                         rowIndex,
//                                                         "discountedPrice",
//                                                         Number(e.target.value)
//                                                     )
//                                                 }
//                                                 isInvalid={!!errors?.pricingAndStocks?.[rowIndex]?.discountedPrice}
//                                             />
//                                             <OverLayButton
//                                                 toolTip="Apply to All"
//                                                 icon={<MdOutlineLibraryAddCheck />}
//                                                 onClick={() =>
//                                                     handleApplyButtonClick(rowIndex, "discountedPrice")
//                                                 }
//                                             />

//                                         </InputGroup>
//                                         {errors?.pricingAndStocks?.[rowIndex]?.discountedPrice && (
//                                             <p className="text-danger fs-10 mb-0 pb-0" >
//                                                 {errors.pricingAndStocks[rowIndex].discountedPrice.message}
//                                             </p>
//                                         )}
//                                     </td>

//                                     {/* Stock */}
//                                     <td>
//                                         <InputGroup>
//                                             <Form.Control
//                                                 type="number"
//                                                 value={row?.quantity || ""}
//                                                 onChange={(e) =>
//                                                     handleInputChange(
//                                                         rowIndex,
//                                                         "quantity",
//                                                         Number(e.target.value)
//                                                     )
//                                                 }
//                                                 isInvalid={!!errors?.pricingAndStocks?.[rowIndex]?.quantity}
//                                             />
//                                             <OverLayButton
//                                                 toolTip="Apply to All"
//                                                 icon={<MdOutlineLibraryAddCheck />}
//                                                 onClick={() =>
//                                                     handleApplyButtonClick(rowIndex, "quantity")
//                                                 }
//                                             />
//                                         </InputGroup>
//                                         {errors?.pricingAndStocks?.[rowIndex]?.quantity && (
//                                             <p className="text-danger fs-10 mb-0 pb-0" >
//                                                 {errors.pricingAndStocks[rowIndex].quantity.message}
//                                             </p>
//                                         )}
//                                     </td>

//                                     {/* SKU */}
//                                     <td>
//                                         <Form.Control
//                                             type="text"
//                                             value={row?.skuCode || ""}
//                                             onChange={(e) =>
//                                                 handleInputChange(rowIndex, "skuCode", e.target.value)
//                                             }
//                                         />
//                                     </td>

//                                     <td>
//                                         <Form.Check
//                                             type="checkbox"
//                                             className="text-center mt-2"
//                                             checked={row?.isDefault ?? false} // ✅ default checked
//                                             onChange={(e) =>
//                                                 handleInputChange(rowIndex, "isDefault", e.target.checked)
//                                             }
//                                         />
//                                     </td>
//                                     <td>
//                                         <Form.Check
//                                             type="checkbox"
//                                             className="text-center mt-2"
//                                             checked={row?.status ?? false} // ✅ default checked
//                                             onChange={(e) =>
//                                                 handleInputChange(rowIndex, "status", e.target.checked)
//                                             }
//                                         />
//                                     </td>
//                                 </tr>
//                             );
//                         })}

//                     </tbody>

//                 </React.Fragment>
//             ))}
//         </table>
//     );
// };

// function generatePermutations(variants) {
//     if (!Array.isArray(variants) || variants.length === 0) return [];

//     return variants.map((variant) => {
//         const groups = (variant.options || []).filter(
//             (g) => Array.isArray(g.options) && g.options.length > 0
//         );

//         const order = groups.map(g => g.name);

//         let permutations = [];

//         // 🔹 SINGLE GROUP
//         if (groups.length === 1) {
//             const group = groups[0];
//             permutations = group.options.map(value => ({
//                 [group.name]: value
//             }));
//         }

//         // 🔹 MULTI GROUP (Cartesian Product)
//         else if (groups.length > 1) {
//             permutations = cartesianProduct(groups);
//         }

//         return {
//             variant: variant.name,
//             order,
//             permutations,
//         };
//     });
// }

// function cartesianProduct(groups) {
//     const result = [];

//     const generate = (index, current) => {
//         if (index === groups.length) {
//             result.push({ ...current });
//             return;
//         }

//         const group = groups[index];

//         group.options.forEach((value) => {
//             generate(index + 1, {
//                 ...current,
//                 [group.name]: value
//             });
//         });
//     };

//     generate(0, {});
//     return result;
// }

// // function generatePermutations(variants) {
// //     if (!Array.isArray(variants) || variants.length === 0) return [];

// //     return variants.map((variant) => {
// //         const order = [];
// //         const groups = [];

// //         // Extract option groups dynamically
// //         (variant.options || []).forEach((group) => {
// //             order.push(group.name); // preserve order

// //             groups.push({
// //                 key: group.name,
// //                 values: group.options || [],
// //             });
// //         });

// //         // Now generate cartesian product of all groups
// //         const permutations = cartesianProduct(groups);

// //         return {
// //             variant: variant.name,
// //             permutations,
// //             order,
// //         };
// //     });
// // }

// // function cartesianProduct(groups) {
// //     if (groups.length === 0) return [];

// //     const result = [];

// //     const generate = (index, current) => {
// //         if (index === groups.length) {
// //             result.push({ ...current });
// //             return;
// //         }

// //         const group = groups[index];

// //         group.values.forEach((value) => {
// //             generate(index + 1, { ...current, [group.key]: value });
// //         });
// //     };

// //     generate(0, {});
// //     return result;
// // }

// // function OverLayButton({ toolTip, onClick, icon }) {
// //     return <OverlayTrigger
// //         overlay={
// //             <Tooltip
// //                 style={{ position: "fixed" }}
// //                 id="overlay-trigger-example"
// //             >
// //                 {toolTip}
// //             </Tooltip>
// //         }
// //     >
// //         <Button
// //             variant="secondary"
// //             onClick={onClick}
// //         >
// //             {icon && icon}
// //         </Button>
// //     </OverlayTrigger>
// // }

// export default PricingAndStockInfoV2;

import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { MdOutlineLibraryAddCheck } from "react-icons/md";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import OverLayButton from "components/common/OverLayButton";
const PricingAndStockInfoV2 = () => {
  const location = useLocation();

  const {
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const [inputs, setInputs] = useState([]);
  const [permutations, setPermutations] = useState([]);

  const generateTrigger = watch("generatePermutations");
  const variants = watch("productVariants");

  // console.log("variants: ", variants)

  useEffect(() => {
    if (!variants || !variants.length) return;

    // 🔹 Generate permutations either on trigger OR when form already has variants (edit mode)
    if (generateTrigger || location.state?.productVariants) {
      const generatedPermutations = generatePermutations(variants);
      setPermutations(generatedPermutations);
    }
  }, [generateTrigger, variants, location.state]);

  // useEffect(() => {
  //     if (!generateTrigger) return;           // ❌ no click yet
  //     if (!variants || !variants.length) return;

  //     const generatedPermutations = generatePermutations(variants);
  //     setPermutations(generatedPermutations);

  // }, [generateTrigger]);

  // const permutations = useMemo(
  //     () => generatePermutations(filteredVariantsOption),
  //     [filteredVariantsOption]
  // );

  // Create dynamic rows
  // useEffect(() => {
  //     const initialInputs = permutations.flatMap((set) =>
  //         set.permutations.map((perm) => {
  //             const entries = Object.values(perm); // ["Red","M","Cotton"]

  //             const obj = {};

  //             // Dynamically create variant1, variant2, variant3...
  //             entries.forEach((value, idx) => {
  //                 obj[`variant${idx + 1}`] = value;
  //             });

  //             // Always include up to variant5 (optional)
  //             for (let i = entries.length + 1; i <= 5; i++) {
  //                 obj[`variant${i}`] = "";
  //             }

  //             return {
  //                 ...obj,
  //                 originalPrice: "",
  //                 discountedPrice: "",
  //                 skuCode: "",
  //                 quantity: "",
  //             };
  //         })
  //     );

  //     setInputs(initialInputs);
  //     setValue("pricingAndStocks", initialInputs);
  // }, [permutations]);

  useEffect(() => {
    if (!permutations.length) return;

    const apiRows = location.state?.pricingAndStocks || [];

    const generatedRows = permutations.flatMap((set) =>
      set.permutations.map((perm) => {
        const entries = Object.values(perm);
        const obj = {};

        entries.forEach((value, idx) => {
          obj[`variant${idx + 1}`] = value;
        });

        for (let i = entries.length + 1; i <= 5; i++) {
          obj[`variant${i}`] = "";
        }

        return obj;
      }),
    );

    const mergedRows = generatedRows.map((row) => {
      const match = apiRows.find((api) =>
        [...Array(5)].every((_, i) => {
          const key = `variant${i + 1}`;
          return (api[key] || "") === (row[key] || "");
        }),
      );

      return {
        ...row,
        originalPrice: match?.originalPrice ?? "",
        discountedPrice: match?.discountedPrice ?? "",
        skuCode: match?.skuCode ?? "",
        quantity: match?.quantity ?? "",
        id: match?.id ?? 0,
        productId: match?.productId ?? 0,
        status: match?.status ?? true,
        isDefault: match?.isDefault ?? false,
      };
    });

    setInputs(mergedRows);
    setValue("pricingAndStocks", mergedRows);
  }, [permutations]);

  const pricingAndStockFound = watch("pricingAndStocks");
  // console.log("pricingAndStockFound", pricingAndStockFound)
  // console.log(pricingAndStockFound)

  useEffect(() => {
    if (pricingAndStockFound) {
      setInputs(pricingAndStockFound);
    }
  }, [pricingAndStockFound]);

  // const handleInputChange = (index, field, value) => {
  //     const updated = inputs.map((row, i) =>
  //         i === index ? { ...row, [field]: value } : row
  //     );
  //     setInputs(updated);
  //     setValue("pricingAndStocks", updated);
  // };

  const handleInputChange = (index, field, value) => {
    let updated;

    if (field === "isDefault") {
      // 🔥 Make it behave like radio
      updated = inputs.map((row, i) => ({
        ...row,
        isDefault: i === index ? value : false,
      }));
    } else {
      updated = inputs.map((row, i) =>
        i === index ? { ...row, [field]: value } : row,
      );
    }

    setInputs(updated);
    setValue("pricingAndStocks", updated);
  };

  const handleApplyAll = (field, value) => {
    const updated = inputs.map((row) => ({ ...row, [field]: value }));
    setInputs(updated);
    setValue("pricingAndStocks", updated);
  };

  const handleApplyButtonClick = (index, field) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want apply to all",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        handleApplyAll(field, inputs[index][field]);
      }
    });
  };

  const handleDiscountedBlur = (index) => {
    const row = inputs[index];
    console.log(row);

    if (
      row &&
      (row.originalPrice === "" ||
        row.originalPrice === 0 ||
        row.originalPrice === null ||
        row.originalPrice === undefined) &&
      row.discountedPrice !== "" &&
      row.discountedPrice !== null &&
      row.discountedPrice !== undefined
    ) {
      const updated = [...inputs];

      updated[index] = {
        ...row,
        originalPrice: row.discountedPrice, // 🔥 copy full value
      };

      setInputs(updated);
      setValue("pricingAndStocks", updated, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  };

  // if (variantsLoading || categoryVariantsLoading) {
  //     return (
  //         <div className="d-flex py-3 justify-content-center align-items-center">
  //             <Button variant="falcon-default" size="sm" className="fs-10">
  //                 Loading...
  //             </Button>
  //         </div>
  //     );
  // }

  return (
    <table className="table table-bordered ">
      {pricingAndStockFound?.length > 0 &&
        permutations.map((set, setIndex) => (
          <React.Fragment key={setIndex}>
            <thead>
              {/* <tr>
                            <th
                                colSpan={set.order.length + 5}
                                className="bg-body-tertiary text-left text-800"
                            >
                                {variants[setIndex]?.name}
                            </th>
                        </tr> */}

              <tr className="bg-body-tertiary text-center text-800">
                {set.order.map((col) => (
                  <th key={col}>{col}</th>
                ))}
                <th>Price</th>
                <th>Special Price</th>
                <th>Stock</th>
                <th>SKU</th>
                <th>Default</th>
                <th>Active</th>
              </tr>
            </thead>

            <tbody>
              {set.permutations.map((perm, permIndex) => {
                const permValues = Object.values(perm);

                const rowIndex = inputs.findIndex((row) =>
                  permValues.every(
                    (val, idx) => row[`variant${idx + 1}`] === val,
                  ),
                );

                const row = inputs[rowIndex];

                return (
                  <tr key={permIndex}>
                    {set.order.map((col, colIndex) => {
                      // Find how many consecutive rows have the same value for this column
                      let rowspan = 1;
                      for (
                        let i = permIndex + 1;
                        i < set.permutations.length;
                        i++
                      ) {
                        if (set.permutations[i][col] === perm[col]) {
                          rowspan++;
                        } else {
                          break;
                        }
                      }

                      // Only render the cell if this is the first occurrence
                      const isFirstOccurrence =
                        permIndex === 0 ||
                        set.permutations[permIndex - 1][col] !== perm[col];

                      return isFirstOccurrence ? (
                        <td
                          key={col}
                          className="text-center align-middle"
                          rowSpan={rowspan}
                        >
                          {perm[col]}
                        </td>
                      ) : null;
                    })}

                    {/* Price */}
                    <td>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          value={row?.originalPrice || ""}
                          onChange={(e) =>
                            handleInputChange(
                              rowIndex,
                              "originalPrice",
                              Number(e.target.value),
                            )
                          }
                          isInvalid={
                            !!errors?.pricingAndStocks?.[rowIndex]
                              ?.originalPrice
                          }
                        />
                        <OverLayButton
                          toolTip="Apply to All"
                          icon={<MdOutlineLibraryAddCheck />}
                          onClick={() =>
                            handleApplyButtonClick(rowIndex, "originalPrice")
                          }
                        />
                      </InputGroup>
                      {errors?.pricingAndStocks?.[rowIndex]?.originalPrice && (
                        <p className="text-danger fs-10 mb-0 pb-0">
                          {
                            errors.pricingAndStocks[rowIndex].originalPrice
                              .message
                          }
                        </p>
                      )}
                    </td>

                    {/* Special Price */}
                    <td>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          value={row?.discountedPrice || ""}
                          onChange={(e) =>
                            handleInputChange(
                              rowIndex,
                              "discountedPrice",
                              Number(e.target.value),
                            )
                          }
                          onBlur={() => handleDiscountedBlur(rowIndex)} // 🔥 add this
                          isInvalid={
                            !!errors?.pricingAndStocks?.[rowIndex]
                              ?.discountedPrice
                          }
                        />
                        <OverLayButton
                          toolTip="Apply to All"
                          icon={<MdOutlineLibraryAddCheck />}
                          onClick={() =>
                            handleApplyButtonClick(rowIndex, "discountedPrice")
                          }
                        />
                      </InputGroup>
                      {errors?.pricingAndStocks?.[rowIndex]
                        ?.discountedPrice && (
                        <p className="text-danger fs-10 mb-0 pb-0">
                          {
                            errors.pricingAndStocks[rowIndex].discountedPrice
                              .message
                          }
                        </p>
                      )}
                    </td>

                    {/* Stock */}
                    <td>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          value={row?.quantity || ""}
                          onChange={(e) =>
                            handleInputChange(
                              rowIndex,
                              "quantity",
                              Number(e.target.value),
                            )
                          }
                          isInvalid={
                            !!errors?.pricingAndStocks?.[rowIndex]?.quantity
                          }
                        />
                        <OverLayButton
                          toolTip="Apply to All"
                          icon={<MdOutlineLibraryAddCheck />}
                          onClick={() =>
                            handleApplyButtonClick(rowIndex, "quantity")
                          }
                        />
                      </InputGroup>
                      {errors?.pricingAndStocks?.[rowIndex]?.quantity && (
                        <p className="text-danger fs-10 mb-0 pb-0">
                          {errors.pricingAndStocks[rowIndex].quantity.message}
                        </p>
                      )}
                    </td>

                    {/* SKU */}
                    <td>
                      <Form.Control
                        type="text"
                        value={row?.skuCode || ""}
                        onChange={(e) =>
                          handleInputChange(rowIndex, "skuCode", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <Form.Check
                        type="checkbox"
                        className="text-center mt-2"
                        checked={row?.isDefault ?? false} // ✅ default checked
                        onChange={(e) =>
                          handleInputChange(
                            rowIndex,
                            "isDefault",
                            e.target.checked,
                          )
                        }
                      />
                    </td>
                    <td>
                      <Form.Check
                        type="checkbox"
                        className="text-center mt-2"
                        checked={row?.status ?? false} // ✅ default checked
                        onChange={(e) =>
                          handleInputChange(
                            rowIndex,
                            "status",
                            e.target.checked,
                          )
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </React.Fragment>
        ))}
    </table>
  );
};

function generatePermutations(variants) {
  if (!Array.isArray(variants) || variants.length === 0) return [];

  return variants.map((variant) => {
    const groups = (variant.options || []).filter(
      (g) => Array.isArray(g.options) && g.options.length > 0,
    );

    const order = groups.map((g) => g.name);

    let permutations = [];

    // 🔹 SINGLE GROUP
    if (groups.length === 1) {
      const group = groups[0];
      permutations = group.options.map((value) => ({
        [group.name]: value,
      }));
    }

    // 🔹 MULTI GROUP (Cartesian Product)
    else if (groups.length > 1) {
      permutations = cartesianProduct(groups);
    }

    return {
      variant: variant.name,
      order,
      permutations,
    };
  });
}

function cartesianProduct(groups) {
  const result = [];

  const generate = (index, current) => {
    if (index === groups.length) {
      result.push({ ...current });
      return;
    }

    const group = groups[index];

    group.options.forEach((value) => {
      generate(index + 1, {
        ...current,
        [group.name]: value,
      });
    });
  };

  generate(0, {});
  return result;
}

export default PricingAndStockInfoV2;
